const isMissing = (value) => value === null || value === undefined || String(value).trim() === "";

const transactionRequiredFields = [
	["TransactionDate", "Transaction Date"],
	["TransactionType", "Transaction Type"],
	["StockCode", "Stock Code"],
	["Currency", "Currency"],
	["NumberOfShares", "No. of Securities"],
	["PricePerShare", "Price per Security"],
	["Brokerage", "Brokerage"]
];

export const getHoldingRequiredFieldErrors = (holding) => {
	const errors = [];

	if (isMissing(holding.HoldingName)) errors.push("Name of Holding is required.");
	if (isMissing(holding.RegisteredOwner)) errors.push("Registered Owner is required.");

	if (holding.showFileUpload) {
		if (!holding.documentList?.length) errors.push("A transaction file is required.");
		return errors;
	}

	const transactions = holding.HoldingTransactions || [];
	if (!transactions.length) errors.push("At least one transaction is required.");

	transactions.forEach((transaction, index) => {
		transactionRequiredFields.forEach(([property, label]) => {
			if (isMissing(transaction[property])) {
				errors.push(`Transaction ${index + 1}: ${label} is required.`);
			}
		});
	});

	return errors;
};